import { render, staticRenderFns } from "./ActivationBriefTasksRouterView.vue?vue&type=template&id=0ab60897&"
import script from "./ActivationBriefTasksRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTasksRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports